// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__-lTC1","choiceBoxes":"toolbarselects_choiceBoxes__1bNj0","simpleField":"toolbarselects_simpleField__2JJc3"};